module.exports = __webpack_public_path__ + "static/media/28DGC1.6bcc0e3b.jpg";